var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuiz(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.625 3H5.375C4.67941 3.00198 4.01288 3.27918 3.52103 3.77103C3.02918 4.26288 2.75198 4.92941 2.75 5.625V14.625C2.75198 15.3206 3.02918 15.9871 3.52103 16.479C4.01288 16.9708 4.67941 17.248 5.375 17.25H7.25V21L11.6431 17.3372C11.7106 17.2808 11.7957 17.25 11.8836 17.25H19.625C20.3206 17.248 20.9871 16.9708 21.479 16.479C21.9708 15.9871 22.248 15.3206 22.25 14.625V5.625C22.248 4.92941 21.9708 4.26288 21.479 3.77103C20.9871 3.27918 20.3206 3.00198 19.625 3V3Z",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.625C8.82843 11.625 9.5 10.9534 9.5 10.125C9.5 9.29657 8.82843 8.625 8 8.625C7.17157 8.625 6.5 9.29657 6.5 10.125C6.5 10.9534 7.17157 11.625 8 11.625Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 11.625C13.3284 11.625 14 10.9534 14 10.125C14 9.29657 13.3284 8.625 12.5 8.625C11.6716 8.625 11 9.29657 11 10.125C11 10.9534 11.6716 11.625 12.5 11.625Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 11.625C17.8284 11.625 18.5 10.9534 18.5 10.125C18.5 9.29657 17.8284 8.625 17 8.625C16.1716 8.625 15.5 9.29657 15.5 10.125C15.5 10.9534 16.1716 11.625 17 11.625Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuiz);
export default __webpack_public_path__ + "static/media/quiz.0a9970b4.svg";
export { ForwardRef as ReactComponent };